import * as ActionTypes from './../constants';
import { baseUrl } from './../constants/apiConstants';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import AsyncStorage from '@react-native-community/async-storage';

export default function(state={}, action) {
    switch(action.type){
        case ActionTypes.REQUEST_HOME_INFO:
            return {
                ...state,
                loading: true,
                err:false,
                errInfo: null,
                status: null
            }
        case ActionTypes.RECEIVED_HOME_INFO:
            return {
                ...state,
                loading: false,
                res: action.res,
                err: false,               
                sliderImages: action.res && action.res.slider_images && action.res.slider_images,
                examPreferences: action.res && action.res.examPreferences && action.res.examPreferences,
                testOfUsers: action.res && action.res.tests_of_user && action.res.tests_of_user,
                testByAdmin: action.res && action.res.tests_by_admin && action.res.tests_by_admin,
                userDetails: action.res && action.res.user_details && action.res.user_details
            }
        case ActionTypes.ERROR_HOME_INFO: 
            return {
                ...state,
                err: true,
                errInfo: action.err && action.err.response && action.err.response.data && action.err.response.data.message,
                loading: false,               
            }
        case ActionTypes.CLEAR_HOME_INFO:
            return { }
        default: return state
    }
}

const dispatchRequestHomeInfo = () => ({
    type: ActionTypes.REQUEST_HOME_INFO,
})
const dispatchReceivedHomeInfo = res => ({
    type: ActionTypes.RECEIVED_HOME_INFO,
    res
})
export const dispatchClearHomeInfo = () => ({
    type: ActionTypes.CLEAR_HOME_INFO    
})
const dispatchErrorHomeInfo = err => ({
    type: ActionTypes.ERROR_HOME_INFO,
    err
})


export function getHomeInfo() {

    return (dispatch, state) => {
        dispatch(dispatchRequestHomeInfo());
        let authKey;
        AsyncStorage.getItem('authKey', (err, res) => {
            if(err) return dispatch(dispatchErrorHomeInfo(err))
            authKey = res;  
            
        const options = {
            method: 'post',
            url: `${baseUrl}/api/home`,
            headers: {"Authorization" : `Bearer ${res}`},
        }

        axios(options)
        .then(({data}) => {
            console.log(data, 'home info');            
            dispatch(dispatchReceivedHomeInfo(data));
        })
        .catch(e => {
            console.log(e, 'err home data');
            dispatch(dispatchErrorHomeInfo(e));
        });
        })
        
    }
}